import React, {MutableRefObject} from 'react';
import MaterialTable from '@material-table/core';

export interface NxTableActionProps<RowData> {
  disabled?: boolean;
  data: RowData;
  size: 'small' | 'medium';
  action: unknown;
  api: {
    // function only works if we use remote data backed by a promise
    onDataUpdated: () => unknown
  }
}

export type NxTableAction<RowData> = React.ComponentType<NxTableActionProps<RowData>>;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export interface NxMaterialTable<RowData> extends MaterialTable<RowData> {
  onQueryChange: () => void;
  isRemoteData: () => boolean;
}

export interface NxTableActionsProps<RowData> {
  data: RowData;
  size: 'small' | 'medium';
  disabled: boolean;
  actions: unknown[];
  materialTableRef: MutableRefObject<NxMaterialTable<RowData> | null>;
  components: {
    Action: React.ComponentClass<NxTableActionProps<RowData>>
  }
}

export enum NxTableColumnAlignment {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum NxTableColumnType {
  BOOLEAN = 'boolean',
  NUMERIC = 'numeric',
  DATE = 'date',
  DATETIME = 'datetime',
}

export interface NxTableColumn<RowData> {
  align?: NxTableColumnAlignment;
  defaultSort?: 'asc' | 'desc',
  field: keyof RowData | string;
  type?: NxTableColumnType;
  title: string;
  width?: number
}

export interface NxQueryResult<RowData> {
  result: RowData[];
  pageNo: number;
  totalCount: number;
}

export interface NxQuery {
  page: number;
  pageSize: number;
}

export interface NxTableDataTest {
  tableName : string;
  rowName : string;
  cellNames : string[];
}

export interface NxTableProps<RowData> {
  rowActions?: NxTableAction<RowData>[];
  columns: NxTableColumn<RowData>[];
  sortable?: boolean;
  data: RowData[] | ((query: NxQuery) => Promise<NxQueryResult<RowData>>);
  isLoading?: boolean;
  negativeMargin?: number;
  selection?: boolean;
  onSelectionChange?: (data: RowData[], rowData?: RowData) => void;
  dataTest?: NxTableDataTest;
}

export interface NxTableRef {
  onQueryChange: () => void;
}